import { NgModule } from '@angular/core';

import { VbPlayerTimePipe } from './VbPlayerTime.Pipe';
import { VbUpdateTranslationParamsPipe } from './VbUpdateTranslationParams.Pipe';

const pipes = [
	VbPlayerTimePipe,
	VbUpdateTranslationParamsPipe
];

@NgModule({
	declarations: pipes,
	exports: pipes
})
export class PipesModule {}
